import { useQueryClient } from "react-query";
import { t } from "@/i18n-js/instance";
import { useConnectModal } from "@/react/components/shared/ConnectModal/ConnectModal";
import { Icon } from "@/react/components/shared/Icon";
import { useToast } from "@/react/components/shared/uikit/ToastV2";
import { useCreateConnection } from "@/react/hooks/connections/useCreateConnection";
import type { CommunityMember } from "@/react/types/CommunityMember";
import { Button } from "@circle-react-uikit/Button";
import { invalidateAllMemberQueries } from "./util";

export const ConnectButton = ({
  recipient,
}: {
  recipient: CommunityMember;
}) => {
  const toast = useToast();
  const queryClient = useQueryClient();
  const connectModal = useConnectModal();

  const { mutate: createConnection, isLoading } = useCreateConnection({
    onSuccess: async () => {
      await invalidateAllMemberQueries(queryClient, recipient.public_uid ?? "");
      toast.success(
        t("profile_drawer.connect_banner.messages.connection_created"),
      );
    },
    onError: () => {
      toast.error(
        t("profile_drawer.connect_banner.messages.connection_creation_error"),
      );
    },
  });

  const handleConnect = (note?: string) => {
    createConnection({ memberId: recipient.id, note });
  };

  const openConnectModal = () => {
    void connectModal.show({
      recipient,
      onConnect: handleConnect,
    });
  };

  return (
    <Button variant="secondary" onClick={openConnectModal} disabled={isLoading}>
      {isLoading ? (
        <Icon type="loader" viewBox="0 0 16 16" />
      ) : (
        t("profile_drawer.connect_banner.states.empty")
      )}
    </Button>
  );
};
